import { clearNativeAccountWorkspace } from '../native/nativeIntentInbox'
import { getNativeReminderNotifications, clearNativeReminderNotifications } from '../native/reminderNotifications'

export async function clearAccountSurfaces(): Promise<void> {
  await clearNativeAccountWorkspace()
  const reminders = getNativeReminderNotifications()
  if (reminders) await clearNativeReminderNotifications(reminders)
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations()
    for (const registration of registrations) {
      for (const notification of await registration.getNotifications()) notification.close()
    }
  }
}
